module.exports = __webpack_public_path__ + "static/wimbledon-01-3257d9e0bec296fd7ebaebac58b8376d.jpg";